import * as insSave from './inf-chg-save.actions';

import { createFeature, createReducer, on } from '@ngrx/store';

import { InfChgSaveI } from 'src/app/api/inf-chg-save/inf-chg-save.result.int';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';

export interface State {
    error: SharedErrorObjectI | null;
    loaded: boolean;
    loading: boolean;
    data: InfChgSaveI;
}

export const initialState: State = {
    error: null,
    loaded: false,
    loading: false,
    data: null
};

export default createFeature({
  name: 'infChgSave',
  reducer: createReducer(
    initialState,
    on(insSave.error, (state: State, { error }): State => ({
        ...state,
        error,
        loaded: false,
        loading: false
    })),
    on(insSave.reset, (state: State): State => ({
        ...state,
        data: null,
        error: null,
        loaded: false,
        loading: false
    })),
    on(insSave.received, (state: State, { result }): State => ({
        ...state,
        data: result,
        error: null,
        loaded: true,
        loading: false,
    })),
    on(insSave.load, (state: State, { }): State => ({
        ...state,
        loaded: false,
        loading: true
    }))
  )}
);